// Loader sekcí z HP (vzor: gabbynaramky.cz).
//
// Princip:
//  - Statická stránka (kontakty, příběh značky, zakázková výroba, …) má v HTML
//    přímo `<div class="myloader">` se sub-loadery uvnitř (`.my-showroom-loader`,
//    `.my-usps-loader`, `.myreviews-loader`).
//  - Detail produktu (`.type-detail`) `.myloader` v HTML nemá, JS si ho vytvoří
//    dynamicky s pevnou strukturou a appendne na konec `.p-detail`.
//  - Pokud na stránce existuje libovolný `.myloader`, fetchne /cache/ (cachovaná HP)
//    a pro každý sub-loader naplní obsahem z odpovídajícího wrapperu z HP.

$(document).ready(function () {
    if ($(".type-detail").length && $(".p-detail").length && $(".detail-loader").length === 0) {
        $(
            "<div class='detail-loader myloader'>" +
            "<div class='myreviews-loader'></div>" +
            "</div>"
        ).appendTo(".p-detail");
    }

    if ($(".myloader").length === 0) {
        return;
    }

    // Na EN mutaci musí cacheUrl mířit na EN homepage — jinak se do EN stránek
    // natáhnou české recenze a USP
    const cacheUrl = getShopDataLayer().homepage.cacheUrl || "/cache/";

    $.get(cacheUrl, function (data) {
        const response = $($.parseHTML(data));

        $(".myloader .my-usps-loader").each(function () {
            $(this).html(response.find(".benefitBanner"));
        });
        $(".myloader .my-showroom-loader").each(function () {
            $(this).html(response.find(".footer-banners"));
        });
        $(".myloader .myreviews-loader").each(function () {
            $(this).html(response.find(".myreviews"));
        });
    }, null, "html").done(function () {
        $("img[data-src]").each(function () {
            $(this).attr("src", $(this).attr("data-src"));
        });
        if (typeof window["initMyreviewsSwiper"] === "function") {
            window["initMyreviewsSwiper"]();
        }
    });
});
